import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import Loader from "./../../../shared/loader";
import Onboarding from '../../../shared/onboarding/onboarding';
import {
  fetchProp,
  assignScenesToProp,
  clearRedirect,
  fetchAllScenes,
  fetchAllCharacters,
  fetchAllSceneSettings,
  fetchScenesAssignedToProp,
  findInScript,
  clearSceneSearchResults,
  setSceneAssignedToProp
} from "./ducks/actions";
import Form from "./scenes-form";
import {
  searchScenes,
  SEARCH_SCENES_FOR_PROPS
} from "../../scenes/search/ducks/actions";
import SearchScenesForm from "../../scenes/search/search-scenes-form";
import ScriptSearch from "../../script/search/script-search";
import { OnboardingStep1ClassName, OnboardingStep2ClassName } from './ducks/reducer';

function PropScenes(props) {
  const propId = props.propId || props.match.params.propId;
  const filmId = props.filmId || props.match.params.filmId;
  const {
    prop,
    fetchAllScenes,
    fetchProp,
    fetchAllCharacters,
    fetchAllSceneSettings,
    fetchScenesAssignedToProp,
    assignScenesToProp,
    setSceneAssignedToProp,
    loadingProp,
    allScenes,
    searchScenes,
    findInScript,
    clearSceneSearchResults,
    errors,
    readOnly,
    sceneId,
    embedded,
    onboardingSteps,
    loadingSceneSettings,
    findingInScript,
    clearRedirect,
    searchingScenes
  } = props;

  const invalidIds = ["add", "scenes"];

  // const allSelectedScenes = (props.selectedSceneIds || []).concat(
  //   props.searchedScenes?.map((s) => s.id)
  // );

  useEffect(() => {
    fetchProp(filmId, propId);
    fetchAllCharacters(filmId);
    if (!sceneId) {
      fetchScenesAssignedToProp(filmId, propId);
    }
  }, [filmId, propId]);

  useEffect(() => {
    if (prop) {
      fetchAllScenes(filmId, prop.characterIds, prop.backgroundCharacterIds);
      fetchAllSceneSettings(filmId, prop.characterIds, prop.backgroundCharacterIds);
    }
  }, [filmId, propId, prop?.characterIds, prop?.backgroundCharacterIds]);

  useEffect(() => {
    if (sceneId) {
      setSceneAssignedToProp(sceneId);
    }
  }, [sceneId]);

  if (!embedded && props.redirect) {
    if (props.redirect.to === "list") {
      clearRedirect();
      const url = `/films/${filmId}/props/overview`;
      return <Redirect to={url} />;
    } else {
      clearRedirect();
      return <Redirect to={props.redirect.to} />;
    }
  }

  const onFindInScript = (e) => {
    e.preventDefault();
    findInScript(filmId, prop.name);
  };

  if (invalidIds.indexOf(propId) > -1) {
    return null;
  }

  function renderLoading() {
    return <Loader />;
  }

  function renderForm() {
    return (
      <div className="blade-content">
        <h2 className="menu-label">Prop Scenes</h2>

        {!readOnly && <div className={`box mt-1 ${OnboardingStep1ClassName}`}>
          <SearchScenesForm
            errors={errors}
            mode="edit"
            filmId={filmId}
            propId={propId}
            loading={loadingProp}
            onSubmit={onSearchScenes}
            findInScript={onFindInScript}
            allSceneSettings={props.allSceneSettings}
            propName={prop?.name}
            searchingScenes={searchingScenes}
            scenes={allScenes}
            showCharacters={false}
            showScriptDays={false}
            showSceneSettings={true}
          />
        </div>}
        {!readOnly && <div className={`box mt-1 ${OnboardingStep2ClassName}`}>
          <ScriptSearch filmId={filmId} text={prop?.name} typeToDispatch="PROPS_SEARCH_SCRIPT" findingInScript={findingInScript} />
        </div>}
        <Form
          errors={errors}
          mode="edit"
          filmId={filmId}
          propId={propId}
          initialValues={{ selectedSceneIds: props.selectedSceneIds }}
          loading={loadingSceneSettings || loadingProp}
          onSubmit={onUpdatePropScenes}
          reduxFormValues={props.reduxFormValues}
          allScenes={props.allScenes}
          searchedSceneIds={props.searchedScenes?.map((s) => s.id)}
          selectSearchedScenes={props.selectSearchedScenes}
          clearSceneSearchResults={clearSceneSearchResults}
          readOnly={readOnly}
        />
        <Onboarding onboardingSteps={onboardingSteps} section="Prop Scenes" />
      </div>
    );
  }

  function onSearchScenes(params) {
    searchScenes(
      SEARCH_SCENES_FOR_PROPS,
      filmId,
      params
    );
  }

  function onUpdatePropScenes(propScenes) {
    // remove any scenes that can't be seen    
    const visibleSceneIds = allScenes.map(s => s.id);
    const selectedSceneIds = propScenes.selectedSceneIds.filter(s => visibleSceneIds.indexOf(s) >= 0);

    assignScenesToProp(filmId, propId, selectedSceneIds);
  }

  return allScenes?.length ? renderForm() : renderLoading();
}

function mapStateToProps(state) {
  const { propsState, form } = state;
  return {
    prop: propsState.prop,
    allScenes: propsState.scenes,
    allCharacters: propsState.characters,
    allSceneSettings: propsState.sceneSettings,
    selectedSceneIds: propsState.selectedSceneIds,
    loadingSceneSettings: propsState.loadingSceneSettings,
    readOnly: propsState.readOnly,
    searchedScenes: propsState.searchedScenes,
    selectSearchedScenes: propsState.selectSearchedScenes,
    findingInScript: propsState.findingInScript,
    searchingScenes: propsState.searchingScenes,
    errors: propsState.errors,
    redirect: propsState.redirect,
    onboardingSteps: propsState.onboardingSteps,
    reduxFormValues: form?.propScenesForm?.values
  };
}

export default
  connect(mapStateToProps, {
    fetchProp,
    fetchAllScenes,
    fetchAllCharacters,
    fetchAllSceneSettings,
    fetchScenesAssignedToProp,
    clearRedirect,
    assignScenesToProp,
    searchScenes,
    findInScript,
    clearSceneSearchResults,
    setSceneAssignedToProp
  })(PropScenes);
